<div class=" mx-auto">
    <div class="bg-white shadow rounded-lg p-6 mb-8 text-center">
        <h1 class="text-3xl font-bold mb-2">Gérer les équipes</h1>
        <p class="text-gray-600">Ajouter, modifier et supprimer des équipes</p>
    </div>
    <div class="bg-white shadow rounded-lg p-8">
        <h2 class="text-xl font-semibold mb-6 text-center">Ajouter une équipe</h2>
        <form [formGroup]="teamForm" (ngSubmit)="onSubmit()" class="space-y-6">
            <div class="flex flex-col md:flex-row gap-6 mb-6">
                <div class="flex-1 flex flex-col gap-2">
                    <label for="name" class="font-medium">Nom de l'équipe</label>
                    <input id="name" formControlName="name" type="text" pInputText class="p-2 border rounded w-full text-[16px]" />
                    <span *ngIf="teamForm.get('name')?.invalid && teamForm.get('name')?.touched"
                        class="text-red-500 text-sm">
                        Nom obligatoire
                    </span>
                </div>
                <div class="flex-1 flex flex-col gap-2">
                    <label for="sport" class="font-medium">Sport</label>
                    <p-dropdown id="sport" formControlName="sport" optionLabel="sport_name" optionValue="id"  type="text"  placeholder="Sport" [options]="sports()"  class=" border rounded w-2/3" >    </p-dropdown>
                    <span *ngIf="teamForm.get('sport')?.invalid && teamForm.get('sport')?.touched"
                        class="text-red-500 text-sm">
                        Sport obligatoire
                    </span>
                </div>


                <div class="flex-1 flex flex-col gap-2">
                    <label for="logo_id" class="font-medium">Id de l'équipe</label>
                    <input id="logo_id" formControlName="logo_id" type="number" pInputText class="p-2 border rounded w-full text-[16px]" />

                </div>




                <div class="flex-1 flex flex-col gap-2">
                    <label for="logo_url" class="font-medium"> Importer le logo</label>

                    <input type="file" (change)="onFileSelected($event)" accept="image/*"
                        class="text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
                    <span *ngIf="teamForm.get('logo_url')?.invalid && teamForm.get('logo_url')?.touched"
                        class="text-red-500 text-sm">
                        Logo obligatoire
                    </span>
                </div>
            </div>
            <p-button type="submit" [icon]="loading ? 'pi pi-spinner pi-spin' : ''"
                [label]="loading ? 'En cours ...' : 'Ajouter l\'équipe'" [disabled]=" loading"></p-button>

        </form>
    </div>
</div>